import styles from "./LoadingSkeleton.module.scss";

interface LoadingSkeletonProps {
  type?: "card" | "text" | "textShort" | "textMedium";
  className?: string;
}

export default function LoadingSkeleton({ type = "card", className = "" }: LoadingSkeletonProps) {
  const getSkeletonClass = () => {
    switch (type) {
      case "card":
        return styles.skeletonCard;
      case "text":
        return styles.skeletonText;
      case "textShort":
        return styles.skeletonTextShort;
      case "textMedium":
        return styles.skeletonTextMedium;
      default:
        return styles.skeletonCard;
    }
  };

  return (
    <div className={`${getSkeletonClass()} ${className}`} />
  );
}
